import GolfIcon from '@/components/GolfIcon';
import { mediumImpact } from '@/utils/capacitorUtils';
import { t } from 'i18next';
import React from 'react';

type FairwayHitType = 'left' | 'center' | 'right' | 'missed' | undefined;

interface FairwayToggleProps {
  value: FairwayHitType;
  onChange: (value: FairwayHitType) => void;
}

const FairwayToggle: React.FC<FairwayToggleProps> = ({ value, onChange }) => {
  const handleToggle = (newValue: FairwayHitType) => {
    mediumImpact();
    onChange(newValue === value ? undefined : newValue);
  };

  return (
    <div className="mb-4">
      <div className="text-sm font-medium mb-2">{t('fairway_accuracy')}</div>
      <div className="grid grid-cols-3 gap-2">
        <button
          onClick={() => handleToggle('left')}
          className={`flex flex-col items-center justify-center border border-solid p-3 rounded-lg transition-colors ${value === 'left'
            ? 'bg-primary/20 border border-primary'
            : 'bg-card hover:bg-accent border border-input'
            }`}
        >
          <GolfIcon name="fairway-left" />
          <span className="text-xs">{t('left')}</span>
        </button>
        <button
          onClick={() => handleToggle('center')}
          className={`flex flex-col items-center justify-center border border-solid p-3 rounded-lg transition-colors ${value === 'center'
            ? 'bg-primary/20 border border-primary'
            : 'bg-card hover:bg-accent border border-input'
            }`}
        >
          <GolfIcon name="fairway-center" />
          <span className="text-xs">{t('center')}</span>
        </button>
        <button
          onClick={() => handleToggle('right')}
          className={`flex flex-col items-center justify-center border border-solid p-3 rounded-lg transition-colors ${value === 'right'
            ? 'bg-primary/20 border border-primary'
            : 'bg-card hover:bg-accent border border-input'
            }`}
        >
          <GolfIcon name="fairway-right" />
          <span className="text-xs">{t('right')}</span>
        </button>
        {/* <IonButton 
          fill={value === 'missed' ? 'solid' : 'outline'}
          size="small"
          onClick={() => handleToggle('missed')}
          className="flex flex-col items-center justify-center"
        >
          <GolfIcon name="fairway-missed" />
          <span className="text-xs">Missed</span>
        </IonButton> */}
      </div>
    </div>
  );
};

export default FairwayToggle;
